import React, { Component } from 'react';
import Modal from './index';
import TermsText from '../../static/da/terms';

export default class TermsModal extends Component {
  render() {
    return (
      <Modal title="Vilkår og retningslinjer for Boligninja.dk" {...this.props}>
        {TermsText}
      </Modal>
    );
  }
}
